import { useEffect, useReducer, useState } from 'react';

const usePagination = (defaultPageSize = 0) => {
  const [qs, setQs] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    { limit: defaultPageSize, offset: 0 }
  );
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [lastPage, _setLastPage] = useState(null);

  const isPaginated = qs.limit > 0;

  const next = () => setPage(page => (page === lastPage ? 1 : page + 1));
  const prev = () => setPage(page => (page === 1 ? lastPage : page - 1));

  const calcLastPage = total =>
    isPaginated ? Math.ceil(total / qs.limit) : null;

  const setLastPage = total => _setLastPage(calcLastPage(total));

  const setPageSize = newPageSize => {
    setPage(1);
    setQs({ limit: Number(newPageSize), offset: 0 });
  };

  const resetPages = () => setPage(1);

  useEffect(() => {
    const offset = (page - 1) * qs.limit;
    setQs({ offset });
  }, [page]);

  useEffect(() => {
    setLastPage(total);
  }, [qs.limit]);

  useEffect(() => {
    setPage(1);
  }, [lastPage]);

  useEffect(() => {
    setLastPage(total);
  }, [total]);

  return isPaginated
    ? {
        qs,
        page,
        setPage,
        resetPages,
        next,
        prev,
        lastPage,
        total,
        setTotal,
        setPageSize,
        pageSize: qs.limit,
        isPaginated
      }
    : { qs: {}, setTotal, resetPages, setPageSize, isPaginated };
};

export default usePagination;
